var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-field"},[_c('VuePlyr',{ref:"plyr",attrs:{"options":{
      fullscreen: { enabled: false },
      settings: [],
      controls: _vm.config.conditions[2].value ? ['play', 'progress'] : ['play']
    },"emit":['ready', 'timeupdate']},on:{"timeupdate":_vm.updatePlayTime}},[_c('div',{staticClass:"plyr__video-embed"},[_c('iframe',{attrs:{"src":_vm.config.conditions[0].value,"allowfullscreen":"","allowtransparency":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }